import { AssignCityRunEventKey, RunEventKey, RunEventKeyPaginationFilterRequest, UpsertRunEventKey } from '@/models/run-event-key.model';
import { deleteReq, postReq } from '../infra/http';
import { getReq, createUrl } from "@/infra/http";
import { PagedResponseModel, BaseResponseModel, PaginatedSelectModel } from "@/models/core.model";

export const getPagedRunEventKeys = async (input: RunEventKeyPaginationFilterRequest): Promise<PagedResponseModel<RunEventKey>> => {
  return await getReq(createUrl("a/RunEvent/Key/PagedData"),
    { params: input }
  ).then((res: any) => res.data);
};

export const getRunEventKeysLookup = async (input?: string, cityId?: number, page?: number): Promise<PaginatedSelectModel> => {
  const model: RunEventKeyPaginationFilterRequest = {
    pageNumber: page ?? 1,
    pageSize: 100,
    keyword: input,
    cityId: cityId,
    isAscending: false
  };
  return await getPagedRunEventKeys(model).then(data => 
    ({ 
      data: data.result.map(itm => ({ 
        value: itm.id, 
        label: itm.name
      })),
      isLastPage: data.pageNumber >= data.totalPages,
    })         
  );
};

export const getRunEventKey = async (id: number): Promise<BaseResponseModel<RunEventKey>> => {
  return await getReq(createUrl(`a/RunEvent/Key/GetById/${id}`),
  ).then((res: any) => res.data);
};

export const upsertRunEventKey = async (input: UpsertRunEventKey): Promise<BaseResponseModel<RunEventKey>> => {
  return await postReq(createUrl("a/RunEvent/Key/Upsert"),
    input
  ).then((res: any) => res.data);
};

export const assignRunEventKeyToCity = async (input: AssignCityRunEventKey) => {
  return await postReq(createUrl("a/RunEvent/Key/City/Assign"),
    input
  ).then((res: any) => res.data);
};

export const unassignRunEventKeyFromCity = async (input: AssignCityRunEventKey) => {
  return await deleteReq(createUrl("a/RunEvent/Key/City/Unassign"),
    { data: input}
  ).then((res: any) => res.data);
};